var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lite-profile-banner"},[_c('h3',{staticClass:"heading"},[_vm._v("Partial Profile")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("This user’s profile is hidden because their subscription is currently inactive.")])])
}]

export { render, staticRenderFns }